/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import {AdTagReplacers} from "./ad-tag-replacers";
import {OgTranslatePipe} from '../common/filters/og-translate.pipe';
import template from './ad-tag.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'ad-tag',
  template
})
export class AdTagComponent implements OnInit {
  scriptLoad: string;
  completeInsertionTag: string;
  tagDesc: string;
  tagDesc2: string;
  detailsPref: boolean;
  @Input() networkTagId: string;
  @Input() tagName: string;
  @Input() insertionTag: string;
  @Input() targetTag: string;
  @Input() whitelabelDomain: string;

  constructor(private readonly ogTranslate: OgTranslatePipe) {
  }

  ngOnInit(): void {
    this.scriptLoad = "\x3Cscript src=\"https://cdn.adnuntius.com/adn.js\" async>\x3C/script>";
    this.scriptLoad = AdTagReplacers.replace(this.scriptLoad, this.whitelabelDomain, this.networkTagId);
    this.insertionTag = AdTagReplacers.replace(this.insertionTag, this.whitelabelDomain, this.networkTagId);
    const scriptLoadPlus = this.scriptLoad + "\n\x3Cscript>";

    // want to put the file load into the script block of the insertion tag.
    this.insertionTag = this.insertionTag.replace("env: 'production', ", "").replace(", env: 'production'", "");
    this.completeInsertionTag = scriptLoadPlus + this.insertionTag;
    const index = this.insertionTag.indexOf("window.adn");
    if (index > -1) {
      this.completeInsertionTag = scriptLoadPlus + this.insertionTag.slice(index);
    }

    this.tagDesc = this.ogTranslate.transform('adUnit.tag.' + this.tagName + '.desc');
    this.tagDesc2 = this.ogTranslate.transform('adUnit.tag.' + this.tagName + '.desc2');
  }
}
